const PeopleIndex = () => import('./Index.vue')
const Users = () => import('./Users.vue')
const User = () => import('./User.vue')
const UserDetails = () => import('./UserDetails.vue')
const UsersSendInvite = () => import('./UsersSendInvite.vue')
const Profiles = () => import('./Profiles.vue')
const ProfileDetails = () => import('./ProfileDetails.vue')

export default [
  {
    name: 'people',
    path: 'people',
    component: PeopleIndex,
    meta: {
      access: ['org.settings.manage', 'org.settings.user.view', 'org.settings.profile.view']
    },
    children: [
      {
        name: 'profiles',
        path: 'profiles',
        component: Profiles,
        meta: {
          access: ['org.settings.manage', 'org.settings.profile.view']
        },
        children: [
          {
            name: 'profile-edit',
            path: ':profileId/edit',
            components: {
              modal: ProfileDetails
            },
            meta: {
              showModal: true,
              access: ['org.settings.manage', 'org.settings.profile.manage']
            }
          },
          {
            name: 'profile-new',
            path: 'new',
            components: {
              modal: ProfileDetails
            },
            meta: {
              showModal: true,
              access: ['org.settings.manage', 'org.settings.profile.manage']
            }
          }
        ]
      },
      {
        name: 'users',
        path: 'users',
        component: Users,
        meta: {
          access: ['org.settings.manage', 'org.settings.user.view']
        },
        children: [
          {
            name: 'user-edit',
            path: ':userId/edit',
            components: {
              modal: UserDetails
            },
            meta: {
              showModal: true,
              access: ['org.settings.manage', 'org.settings.user.manage']
            }
          },
          {
            name: 'user-new',
            path: 'new',
            components: {
              modal: UserDetails
            },
            meta: {
              showModal: true,
              access: ['org.settings.manage', 'org.settings.user.manage']
            }
          },
          {
            name: 'users-invite',
            path: 'invite',
            components: {
              modal: UsersSendInvite
            },
            meta: {
              showModal: true,
              access: ['org.settings.manage', 'org.settings.user.manage']
            }
          }
        ]
      },
      {
        name: 'user',
        path: 'user/:userId',
        component: User,
        meta: {
          access: ['org.settings.manage', 'org.settings.user.view']
        },
        children: [
          {
            name: 'selectedUser-edit',
            path: 'edit',
            components: {
              modal: UserDetails
            },
            meta: {
              showModal: true,
              access: ['org.settings.manage', 'org.settings.user.manage']
            }
          }
        ]
      }
    ]
  }
]
